import { render } from "./DocEditPopup.vue?vue&type=template&id=335a549b&scoped=true"
import script from "./DocEditPopup.vue?vue&type=script&lang=js"
export * from "./DocEditPopup.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./DocEditPopup.vue?vue&type=style&index=1&id=335a549b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335a549b"]])

export default __exports__